export default __webpack_public_path__ + "static/media/image-ph-health-statistics-w@3x.cabf97f2.png";